import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
import _imports_0 from '@/assets/discuss/empty.png';
var _hoisted_1 = {
  class: "bei-prepare"
};
var _hoisted_2 = {
  key: 1,
  class: "empty"
};
var _hoisted_3 = {
  key: 1,
  class: "empty"
};
import SubTab from '../../Components/SubTab';
import Discuss from './Discuss';

/* 工具 */
import { ref, provide, onMounted, onUnmounted } from 'vue';
import WujieVue from 'wujie-vue3';

/* api */
import { activeDiscussTask, getActivityAuth } from '@/api/index-bei-discuss';

/* 变量 */

export default {
  __name: 'index',
  setup: function setup(__props) {
    /* 组件 */
    var bus = WujieVue.bus;
    var hasAuth = ref(false);
    var tabs = ref([]);
    var tabId = ref(0);
    var showDiscuss = ref(false);
    var isLoading = false;
    provide('discussId', tabId);

    /* 事件 */
    var getAuth = function getAuth() {
      return new Promise(function (resolve) {
        getActivityAuth().then(function (res) {
          resolve(true);
        }).catch(function (err) {
          resolve(false);
        });
      });
    };
    var getTabs = function getTabs() {
      if (isLoading) return;
      isLoading = true;
      showDiscuss.value = false;
      activeDiscussTask().then(function (res) {
        if (res.data.code === 0) {
          var _res$data;
          var list = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) || [];
          tabs.value = list.map(function (item) {
            return {
              name: item.discussName,
              value: item.discussId,
              exist: true
            };
          });
          if (tabs.value.length > 0) {
            tabId.value = tabs.value[0].value;
            showDiscuss.value = true;
          }
        }
      }).finally(function () {
        isLoading = false;
      });
    };
    var tabChange = function tabChange(item) {
      tabId.value = item.value;
      showDiscuss.value = false;
      setTimeout(function () {
        showDiscuss.value = true;
      }, 100);
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            bus.$on('index-bei-discuss-reload', function () {
              getTabs();
            });
            _context.n = 1;
            return getAuth();
          case 1:
            hasAuth.value = _context.v;
            hasAuth.value && getTabs();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    onUnmounted(function () {
      bus.$off('index-bei-discuss-reload');
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [hasAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [tabs.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_unref(SubTab), {
        class: "shrink",
        tabs: tabs.value,
        "default-index": tabId.value,
        onChange: tabChange
      }, null, 8, ["tabs", "default-index"]), showDiscuss.value ? (_openBlock(), _createBlock(_unref(Discuss), {
        key: 0,
        class: "flex1"
      })) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "暂无教研活动", -1)]))))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "暂无应用权限", -1)]))))]);
    };
  }
};